import type { CommunityList, LabelInValue } from 'models';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useCommunitySelectCreateOption } from 'features/communities/components/community-select';

export type CommunityOption = { data: CommunityList } & LabelInValue;

export const useEventCommunityCreateOption = () => {
  const createOption = useCommunitySelectCreateOption();

  return useCallback(
    (community: CommunityList): CommunityOption => ({
      ...createOption(community),
      data: community,
    }),
    [createOption],
  );
};
